export default "__VITE_ASSET__707c9efa__"